(()=>{
  const dialog=document.querySelector('[data-gallery-dialog]');
  const opener=document.querySelector('[data-gallery-open]');
  if(!dialog||!opener||typeof dialog.showModal!=='function')return;
  const gallery=opener.closest('.product-gallery');
  const stage=dialog.querySelector('[data-lightbox-stage]');
  const image=dialog.querySelector('[data-lightbox-image]');
  const zoom=dialog.querySelector('[data-lightbox-zoom]');
  const previous=dialog.querySelector('[data-lightbox-prev]');
  const next=dialog.querySelector('[data-lightbox-next]');
  let photos=[],index=0,zoomed=false,oldOverflow='',returnFocus=null;
  const setZoom=value=>{
    zoomed=value;stage.classList.toggle('is-zoomed',value);
    zoom.setAttribute('aria-pressed',String(value));zoom.textContent=value?'Dopasuj −':'Powiększ +';
    stage.scrollTop=0;stage.scrollLeft=0;
  };
  const show=()=>{
    const photo=photos[index];if(!photo)return;
    setZoom(false);image.src=photo.dataset.galleryLarge||photo.dataset.galleryImage;image.alt=photo.dataset.galleryAlt||'Zdjęcie wybranego wariantu';
    dialog.querySelector('[data-lightbox-caption]').textContent=image.alt;
    dialog.querySelector('[data-lightbox-counter]').textContent=(index+1)+' / '+photos.length;
    previous.disabled=next.disabled=photos.length<2;
  };
  const step=offset=>{index=(index+offset+photos.length)%photos.length;show();};
  opener.hidden=false;
  opener.addEventListener('click',()=>{
    photos=[...gallery.querySelectorAll('[data-gallery-image]')].filter(photo=>!photo.hidden);
    if(!photos.length)return;
    index=Math.max(0,photos.findIndex(photo=>photo.getAttribute('aria-pressed')==='true'));
    returnFocus=document.activeElement;oldOverflow=document.body.style.overflow;
    show();dialog.showModal();document.body.style.overflow='hidden';
  });
  dialog.querySelector('[data-lightbox-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>{document.body.style.overflow=oldOverflow;setZoom(false);returnFocus?.focus({preventScroll:true});});
  previous.addEventListener('click',()=>step(-1));next.addEventListener('click',()=>step(1));
  zoom.addEventListener('click',()=>setZoom(!zoomed));image.addEventListener('click',()=>setZoom(!zoomed));
  dialog.addEventListener('keydown',event=>{
    if(!zoomed&&photos.length>1&&['ArrowLeft','ArrowRight'].includes(event.key)){
      event.preventDefault();step(event.key==='ArrowLeft'?-1:1);
    }
  });
})();
